module.exports = __webpack_public_path__ + "img/show_cn_text_14.2caf1781.png";